import { ContentCard } from '../components';
import { EducationData } from '../utils/text-data/education';
import { TimelineComponent } from '../components/timeline';

export const EducationSection = () => {
  return (
    <ContentCard cardTitle={'Education'} className='gap-4'>
      <TimelineComponent
        dataList={EducationData}
        hideDuration
        // timelineDot='🎓'
      />
    </ContentCard>
  );
};
